import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "thunder",
  "use": "thunder-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"thunder\"><path d=\"M11 1.5 4.5 10h4L7 16.5 13.5 8h-4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol